import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../hooks/useAuth'

export default function LoginPage() {
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const { login } = useAuth()
  const nav = useNavigate()

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    setError('')
    setLoading(true)
    try {
      await login(username, password)
      nav('/')
    } catch (err: any) {
      setError(err.response?.data?.detail || 'Error al iniciar sesión')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center p-4">
      <div
        className="w-full max-w-md p-8"
        style={{
          background: 'linear-gradient(160deg, rgba(255,255,255,.08), rgba(255,255,255,.03))',
          border: '1px solid rgba(140,170,230,.18)',
          borderRadius: 26,
          boxShadow: 'inset 0 1px 0 rgba(255,255,255,.10), 0 40px 90px -30px rgba(0,110,180,.55)',
        }}
      >
        <div className="flex flex-col items-center mb-7">
          <img
            src="/avante-logo-white.png"
            alt="Avante Complejo Hospitalario"
            style={{ height: 48, marginBottom: 14 }}
            onError={(e) => ((e.target as HTMLImageElement).style.display = 'none')}
          />
          <h1
            className="text-2xl font-bold text-center"
            style={{ fontFamily: 'Space Grotesk', color: '#E6EAF7' }}
          >
            Avante Dietas
          </h1>
          <p className="text-xs mt-1" style={{ color: '#94A0CD' }}>
            Gestión de dietas hospitalarias
          </p>
        </div>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-[11px] uppercase tracking-[0.12em] font-semibold mb-1" style={{ color: '#8B97C8' }}>
              Usuario
            </label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              autoComplete="username"
              className="w-full p-3 border rounded focus:outline-none"
            />
          </div>
          <div>
            <label className="block text-[11px] uppercase tracking-[0.12em] font-semibold mb-1" style={{ color: '#8B97C8' }}>
              Contraseña
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              autoComplete="current-password"
              className="w-full p-3 border rounded focus:outline-none"
            />
          </div>
          {error && <p className="text-sm" style={{ color: '#FF5C7A' }}>{error}</p>}
          <button
            type="submit"
            disabled={loading}
            className="w-full py-3 font-semibold text-white disabled:opacity-50 relative overflow-hidden"
            style={{
              minHeight: 48,
              borderRadius: 16,
              background: 'linear-gradient(120deg,#006EB4,#143C78)',
              boxShadow: '0 14px 30px -10px rgba(0,110,180,.7)',
            }}
          >
            <span
              aria-hidden
              style={{
                position: 'absolute', top: 0, bottom: 0, width: '40%',
                background: 'linear-gradient(90deg,transparent,rgba(255,255,255,.35),transparent)',
                animation: 'avSheen 3.2s ease-in-out infinite',
              }}
            />
            {loading ? 'Ingresando...' : 'Ingresar'}
          </button>
        </form>
      </div>
    </div>
  )
}
